<template>
  <CommonTable
    :static-dispatch-params="{ template_id: $route.params.id }"
    list-getter="documentImageStore/getList"
    create-item-dispatch="documentImageStore/create"
    update-item-dispatch="documentImageStore/update"
    delete-item-dispatch="documentImageStore/delete"
    :headers="headers"
    :slots="slots"
    resource="document-images"
    can-add
    can-edit
    can-delete
    @updated="updateList"
  >
  </CommonTable>
</template>

<script>
import CommonTable from "../common/tables/CommonTable";
import { rules } from "../mixins/rules";

export default {
  name: "ImagesTemplateLibrary",
  props: ["id"],
  components: { CommonTable },
  mixins: [rules],
  data: function() {
    return {
      headers: [
        {
          text: this.$t("document-images.id"),
          align: "left",
          value: "id"
        },
        {
          text: this.$t("document-images.name"),
          value: "name"
        },
        {
          text: this.$t("document-images.image"),
          value: "image"
        },
        {
          text: this.$t("document-images.created_at"),
          value: "created_at"
        },
        {
          text: this.$t("document-images.updated_at"),
          value: "updated_at"
        },
        {
          text: this.$t("document-images.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ]
    };
  },
  computed: {
    slots() {
      let rules = this.rules;
      return [
        {
          name: "created_at",
          type: "date",
          human: true
        },
        {
          name: "updated_at",
          type: "date",
          human: true
        },
        {
          name: "image",
          type: "document-image",
          title: "image",
          form: {
            type: "file-input",
            name: "image",
            accept: "image/*",
            hideInput: true,
            visible: true
          }
        },
        {
          name: "name",
          form: {
            type: "text",
            rules: [rules.required],
            visible: true
          }
        }
      ];
    }
  },
  methods: {
    updateList() {
      let params = { template_id: this.$route.params.id };
      this.$store.dispatch("documentImageStore/getList", {
        params
      });
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>
